module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat"
  }, [_c('iframe', {
    attrs: {
      "src": "https://livechat.connexease.com/embed/5d432f58-c1e6-4b09-b5ce-481421020719"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58f4f397"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat.vue
// module id = 235
// module chunks = 1